<div class="edit-account-root">
  <div class="edit-account-header">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
          {{
          kycHeaderInfo?.surname + " " + kycHeaderInfo?.firstName | hasValue
          }}
        </div>
        <div class="slrn">
          {{ kycHeaderInfo?.slrn ? kycHeaderInfo?.slrn : ("COMMON.NO_SLRN" | translate) }}
        </div>
        <div class="application-number">
          {{ kycHeaderInfo?.applicationNumber }}
        </div>
        <div class="row">
          <div class="entry-status new-entry col-12" *ngIf="!accountInfo?.accountNumber">
            {{'COMMON.NEW_ENTRY' | translate}}
          </div>
          <div class="entry-status existing-entry col-12" *ngIf="accountInfo?.accountNumber">
            {{'COMMON.EXISTING' | translate}}
          </div>
        </div>
        <div *ngIf="accountInfo?.customerInformation" class="row">
          <div class="customer-type col-12">
            {{ accountInfo?.customerInformation?.buildingType | hasValue }}
          </div>
        </div>
        <div class="row">
          <div [ngClass]="{
                'pending-account': accountInfo?.currentStatus === 'Pending',
                'rejected-account': accountInfo?.currentStatus === 'Rejected',
                'complete-account': accountInfo?.currentStatus === 'Complete',
                'incomplete-account': accountInfo?.currentStatus === 'Incomplete' || accountInfo?.currentStatus === 'InProgress',
                'suspended-account': accountInfo?.currentStatus === 'Suspended'
              }" class="col-12 account-status" *ngIf="accountInfo?.currentStatus">
            {{ 'COMMON.KYC_STATUS_OPTIONS.' + accountInfo?.currentStatus | uppercase | translate }}
          </div>
        </div>
      </div>
      <div class="user-address">
        <div>{{ kycHeaderInfo?.email | hasValue }}</div>
        <div>
          {{ kycHeaderInfo?.phoneNumber | hasValue }}
        </div>
        <div>
          {{ kycHeaderInfo?.address | hasValue }}
        </div>
      </div>
    </div>
    <div class="action-buttons" *ngIf="!onlyView">
      <div class="recall-div" *ngIf="permissionsService.isNewServiceRecallValidatedAllowed && !onboardedCustomersDetails && (accountInfo?.currentStatus === 'Suspended' || accountInfo?.currentStatus === 'Rejected' || accountInfo?.currentStatus === 'Complete')">
        <button class="btn btn-header recall-button" style="color: black" (click)="showRecallMenu = !showRecallMenu">
          <span class="recall-span">{{'COMMON.RECALL' | translate}}</span>
        </button>
        <div *ngIf="showRecallMenu" class="recall-options">
          <div class="recall-type recall-type-enabled" (click)="recallValidation()">
            <span>{{'COMMON.VALIDATED_TASK' | translate}}</span>
          </div>
        </div>
      </div>
      <button class="btn btn-header" data-bs-toggle="modal" data-bs-target="#updateStatus" [disabled]="
            !permissionsService.isNewServiceApproveRejectAllowed ||
            accountInfo?.currentStatus !== 'Pending'
          ">
        {{'COMMON.UPDATE_STATUS' | translate}}
      </button>
      <button class="btn btn-header" *ngIf="
            !editEnabled &&
            permissionsService.isNewServiceCreateEditAllowed
          " (click)="edit()">
        {{'COMMON.EDIT' | translate}}
      </button>
      <button class="btn btn-primary" *ngIf="editEnabled" (click)="save()">
        {{'COMMON.SAVE' | translate}}
      </button>
    </div>
  </div>
  <div class="edit-accounts-body row">
    <div class="col-13 col-md-4">
      <div class="row">
        <div class="card container col-11">
          <div class="row">
            <div class="col-4">{{'COMMON.MBC_DETAILS.CUSTOMER_NAME' | translate}}</div>
            <div *ngIf="!editEnabled" class="col-8">
              {{
              (accountInfo?.surname ?? '') + " " + accountInfo?.firstName | hasValue
              }}
            </div>
            <ng-container *ngIf="editEnabled">
              <input [placeholder]="'COMMON.FIRST_NAME' | translate" class="col-4 info-edit" type="text"
                [(ngModel)]="accountInfo.firstName" />
              <input [placeholder]="'COMMON.SURNAME' | translate" class="col-4 info-edit" type="text"
                [(ngModel)]="accountInfo.surname" />
            </ng-container>
          </div>
          <div class="row">
            <div class="col-5">{{ 'COMMON.MBC_DETAILS.CUSTOMER_ADDRESS' | translate }}</div>
            <div class="col-7">
              {{
                accountInfo?.addressOfLandlord?.street + ' ' +
                accountInfo?.addressOfLandlord?.houseNo + ', ' +
                accountInfo?.addressOfLandlord?.landmark
              }}
            </div>
          </div>
          <div class="row">
              <div class="col-5">{{'COMMON.CUSTOMER.ACCOUNT_NUMBER' | translate}}</div>
              <div class="col-7">
                {{
                  accountInfo?.accountNumber | hasValue
                }}
              </div>
            </div>
            <div class="row">
              <div class="col-5">{{'COMMON.MBC_DETAILS.METER_NO' | translate}}</div>
              <div class="col-7">
                {{
                  accountInfo?.customerInformation?.meterNumber | hasValue
                }}
              </div>
            </div>
            <div class="row">
              <div class="col-5">{{'COMMON.BU.SINGLE' | translate}}</div>
              <div class="col-7">
                {{
                  accountInfo?.addressOfLandlord?.region | hasValue
                }}
              </div>
            </div>
            <div class="row">
              <div class="col-5">{{'COMMON.UT.SINGLE' | translate}}</div>
              <div class="col-7">
                {{
                  accountInfo?.addressOfLandlord?.area | hasValue
                }}
              </div>
            </div>
            <div class="row">
              <div class="col-5">{{'COMMON.MBC_DETAILS.FEEDER_NAME' | translate}}</div>
              <div class="col-7">
                {{
                  accountInfo?.customerInformation?.dt?.feeder?.name | hasValue
                }}
              </div>
            </div>
            <div class="row">
              <div class="col-5">{{'COMMON.MBC_DETAILS.FEEDER_NUMBER' | translate}}</div>
              <div class="col-7">
                {{
                  accountInfo?.customerInformation?.dt?.feeder?.number | hasValue
                }}
              </div>
            </div>
            <div class="row">
              <div class="col-4">{{'COMMON.DT_NAME' | translate}}</div>
              <div class="col-8">
                {{ accountInfo?.customerInformation?.dt?.name | hasValue }}
              </div>
            </div>
            <div class="row">
              <div class="col-5">{{'COMMON.DT_NUMBER' | translate}}</div>
              <div class="col-7">
                {{ accountInfo?.customerInformation?.dt?.number | hasValue }}
              </div>
            </div>
          </div>  
          <div class="card container col-11">
            <label class="section-label">{{'SERVICE_POINT_DATA.TITLE' | translate}}</label>
            <div class="row">
              <div [ngClass]="{ 'col-4': editEnabled, 'col-6': !editEnabled }">
                {{'SERVICE_POINT_DATA.REQUIRED_SUPPLY_ADDRESS' | translate}}
              </div>
              <div *ngIf="!editEnabled" class="col-6">
                <ng-container *ngIf="accountInfo?.addressOfLandlord?.houseNo">
                  {{'COMMON.NO' | translate}}.
                </ng-container>
                {{ accountInfo?.addressOfLandlord?.houseNo | hasValue }}
                {{ accountInfo?.addressOfLandlord?.street | hasValue }},
                {{ accountInfo?.addressOfLandlord?.landmark | hasValue }}
              </div>
              <input
                [placeholder]="('COMMON.NO' | translate) + '.'"
                *ngIf="editEnabled"
                class="info-edit col-2"
                [(ngModel)]="accountInfo.addressOfLandlord.houseNo"
              />
              <input
                [placeholder]="'COMMON.STREET_NAME' | translate"
                *ngIf="editEnabled"
                class="col-6 info-edit address-edit-street"
                [(ngModel)]="accountInfo.addressOfLandlord.street"
              />
            </div>
         
            <div class="row">
              <div class="col-4">{{'SERVICE_POINT_DATA.REGION' | translate}}</div>

              <div *ngIf="!editEnabled" class="col-8">
                {{ accountInfo?.addressOfLandlord?.region | hasValue }}
              </div>
              <select
                *ngIf="editEnabled && !authService.hasCimDataIntegration"
                class="col-8 info-edit"
                [(ngModel)]="selectedRegionId"
                (ngModelChange)="onRegionChange($event)"
              >
                <option [ngValue]="0" disabled>
                  {{ 'SERVICE_POINT_DATA.REGION' | translate }}
                </option>
                <option
                  *ngFor="let region of regionOptions"
                  [ngValue]="region.key"
                >
                  {{ region.value }}
                </option>
              </select>
              <select
                *ngIf="editEnabled && authService.hasCimDataIntegration"
                class="col-8 info-edit"
                [(ngModel)]="selectedGeoRegionId"
                (ngModelChange)="onGeoRegionChange($event)"
              >
                <option [ngValue]="0" disabled>
                  {{ 'SERVICE_POINT_DATA.REGION' | translate }}
                </option>
                <option *ngFor="let geoRegion of geoRegions" [ngValue]="geoRegion.id">
                  {{ geoRegion.name }}
                </option>
              </select>
            </div>
            <div class="row">
              <div class="col-4">{{'SERVICE_POINT_DATA.AREA' | translate}}</div>

              <div *ngIf="!editEnabled" class="col-8">
                {{ accountInfo?.addressOfLandlord?.area | hasValue }}
              </div>
              <select
                *ngIf="editEnabled && !authService.hasCimDataIntegration"
                class="col-8 info-edit"
                [(ngModel)]="selectedAreaId"
                (ngModelChange)="onAreaChange($event)"
              >
                <option [ngValue]="0" disabled>
                  {{ 'SERVICE_POINT_DATA.AREA' | translate }}
                </option>
                <option
                  *ngFor="let area of areaOptions"
                  [ngValue]="area.key"
                >
                  {{ area.value }}
                </option>
              </select>
              <select
                *ngIf="editEnabled && authService.hasCimDataIntegration"
                class="col-8 info-edit"
                [(ngModel)]="accountInfo.addressOfLandlord.subGeographicalRegionId"
                (ngModelChange)="onSubGeoRegionChange($event)"
              >
                <option [ngValue]="null" disabled>
                  {{ 'SERVICE_POINT_DATA.AREA' | translate }}
                </option>
                <option *ngFor="let subGeoRegion of selectableSubGeoRegions" [ngValue]="subGeoRegion.id">
                  {{ subGeoRegion.name }}
                </option>
              </select>
            </div>
            <div class="row">
              <div class="col-4">{{'SERVICE_POINT_DATA.USE_OF_PREMISES' | translate}}</div>
  
              <div class="col-8">
                {{ accountInfo?.useOfPremises | hasValue }}
              </div>
            </div>
            <div class="row">
              <div class="col-4">{{'SERVICE_POINT_DATA.PREMISES_TYPE' | translate}}</div>
  
              <div class="col-8">
                {{ accountInfo?.typeOfPremises?.toString() | hasValue }}
              </div>
            </div>
            <div class="row">
              <div class="col-4">{{'SERVICE_POINT_DATA.PREMISE_CATEGORY' | translate}}</div>
  
              <div class="col-8">
                {{ accountInfo?.premiseCategory | hasValue }}
              </div>
            </div>
            <div class="row">
              <div class="col-4">{{'SERVICE_POINT_DATA.ACTIVITY' | translate}}</div>
  
              <div class="col-8">
                {{ accountInfo?.activity | hasValue }}
              </div>
            </div>
            <div class="row">
              <div class="col-4">{{'SERVICE_POINT_DATA.SUBACTIVITY' | translate}}</div>
  
              <div class="col-8">
                {{ accountInfo?.subactivity | hasValue }}
              </div>
            </div>
            <div class="row">
              <div class="col-4">{{'SERVICE_POINT_DATA.BUILDING_DEVELOPMENT' | translate}}</div>
  
              <div class="col-8">
                {{ accountInfo?.buildingDevelopmentStage | hasValue }}
              </div>
            </div>
            <div class="row">
              <div class="col-4">{{'SERVICE_POINT_DATA.GEOLOCATION' | translate}}</div>

              <div class="locationText col-7">
                <ng-container *ngIf="accountInfo?.latitude != null && accountInfo?.longitude != null; else noGeolocation">
                  {{ accountInfo?.latitude }}, {{ accountInfo?.longitude }}
                </ng-container>
                <ng-template #noGeolocation>
                  {{ '' | hasValue }}
                </ng-template>
              </div>
              <div class="location col-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 500 500"
                  (click)="openGeolocationMap(accountInfo?.latitude, accountInfo?.longitude)"
                  [attr.data-bs-toggle]="accountInfo?.latitude != null && accountInfo?.longitude != null ? 'modal' : null"
                  [attr.data-bs-target]="accountInfo?.latitude != null && accountInfo?.longitude != null ? '#showMap' : null"
                >
                  <path
                    d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
                    fill="#026962"
                  />
                </svg>
              </div>
            </div>
          </div>

          <app-user-activity-section [kycAccountId]="customerId"></app-user-activity-section>

      </div>
    </div>
    <div class="col-13 col-md-4">
      <div class="row">
          <div class="card container col-11">
            <label class="section-label">{{'CUSTOMER_DATA.TITLE' | translate}}</label>
            <div class="row">
              <div class="col-5">{{ 'CUSTOMER_DATA.ACC_NAME' | translate }}</div>

            <div class="col-7">
              {{ (accountInfo?.surname + ' ' + accountInfo?.firstName) | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-5">{{'PERSONAL_DATA.CUSTOMER_PHONE_NO' | translate}}</div>
            <div *ngIf="!editEnabled" class="col-7">
              <p>
                <ng-container *ngIf="accountInfo?.buildingOwnerDialCode">
                  +
                </ng-container>
                {{ accountInfo?.dialCode | hasValue }}
                {{ accountInfo?.phoneNumber | hasValue }}
              </p>
            </div>
            <input [placeholder]="'PERSONAL_DATA.CODE' | translate" *ngIf="editEnabled" class="info-edit col-2"
              [(ngModel)]="accountInfo.dialCode" />
            <input [placeholder]="'PERSONAL_DATA.PHONE_NO' | translate" *ngIf="editEnabled" class="info-edit col-5"
              [(ngModel)]="accountInfo.phoneNumber" />
          </div>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.EMAIL' | translate }}</div>
            <div *ngIf="!editEnabled" class="col-7">
              {{ accountInfo?.email }}
            </div>
            <input [placeholder]="'PERSONAL_DATA.CODE' | translate" *ngIf="editEnabled" class="info-edit col-7"
              [(ngModel)]="accountInfo.email" />
          </div>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.OWNERSHIP_STATUS' | translate }}</div>

            <div class="col-7">
              {{ accountInfo?.ownershipStatus | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-6">{{ 'CUSTOMER_DATA.BUILDING_OWNER' | translate }}</div>

            <div *ngIf="!editEnabled" class="col-6">
              {{ accountInfo?.buildingOwner | hasValue }}
            </div>
            <input *ngIf="editEnabled && accountInfo?.ownershipStatus !== 'Owner'"
              [placeholder]="'PERSONAL_DATA.BUILDING_OWNER_NAME' | translate" class="info-edit col-6"
              [(ngModel)]="accountInfo.buildingOwner" />
          </div>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.CUSTOMER_IDENTIFICATION' | translate }}</div>

            <div class="col-7">
              {{ accountInfo?.identificationOfLandlord | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.PERSONAL_ID_NUM' | translate }}</div>

            <div class="col-7">
              {{ accountInfo?.personalIdNumberOfLandlord | hasValue }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{ 'CUSTOMER_DATA.DATE_OF_BIRTH' | translate }}</div>

            <div class="col-8">
              {{ accountInfo?.dateOfBirth | date : "dd/MM/yyyy" }}
            </div>
          </div>
          <div class="row">
            <div class="col-5">{{ 'CUSTOMER_DATA.NATIONALITY' | translate }}</div>

            <div class="col-7">
              {{ accountInfo?.nationality | hasValue }}
            </div>
          </div>

            <div class="row">
              <div class="col-5">{{ 'CUSTOMER_DATA.GENDER' | translate }}</div>
  
              <div class="col-7">
                {{ accountInfo?.gender | hasValue }}
              </div>
            </div>
              <div class="row">
                <div class="col-5">{{ 'CUSTOMER_DATA.NIN' | translate }}</div>

                <div class="col-7">
                  {{ accountInfo?.nin | hasValue }}
                  <app-nin-verification-popup
                    [nin]="accountInfo?.nin"
                    [accountId]="accountInfo?.id"
                  ></app-nin-verification-popup>
                </div>
              </div>
               <div class="row">
              <div class="col-4">{{'SERVICE_POINT_DATA.SERVICE_TYPE' | translate}}</div>
  
              <div class="col-8">
                {{ accountInfo?.serviceType | hasValue }}
              </div>
            </div>
               <div class="row">
              <div class="col-4">{{'SERVICE_POINT_DATA.SUB_SERVICE_TYPE' | translate}}</div>
  
              <div class="col-8">
                {{ subServieSpaces(accountInfo?.subServiceType) | hasValue }}
              </div>
            </div>
            <div *ngIf="accountInfo?.identificationIssueDate" class="row">
              <div class="col-5">Identification Issue Date</div>
            
              <div class="col-7">
                {{ accountInfo?.identificationIssueDate | date : "dd/MM/yyyy" }}
              </div>
            </div>
            <div *ngIf="accountInfo?.identificationExpiryDate" class="row">
              <div class="col-5">Identification Expiry Date</div>
            
              <div class="col-7">
                {{ accountInfo?.identificationExpiryDate | date : "dd/MM/yyyy" }}
              </div>
            </div>
            <div class="row">
              <div class="col-5">Customer Type</div>
            
              <div class="col-7">
                {{ customerType | hasValue }}
              </div>
            </div>
            <div class="row">
              <div class="col-5">Client Type</div>
            
              <div class="col-7">
                {{ clientType | hasValue }}
              </div>
            </div>
          </div>

          <div class="card container col-11">
            <label class="section-label"
              >{{'PERSONAL_DATA.DECLARATION' | translate}}</label
            >
            <div
              class="row"
              *ngFor="let loadItem of this.accountInfo?.loadRequirements"
            >
              <div class="col-6">
                {{ loadItem.name }}
              </div>
  
              <div class="col-2">
                {{ loadItem.number }}
              </div>
              <div class="col-4">
                {{ loadItem.wattage }}
              </div>
            </div>
            <div class="row">
              <div class="col-6">Total load</div>
  
              <div class="col-2">
                ----
              </div>
              <div class="col-4">
                {{ totalLoad }}
              </div>
            </div>
          </div>
          <app-meter-request-section class="card"
            [relatedAccounts]="accountInfo?.relatedAccounts"
            [accountKycId]="accountInfo?.id ?? 0"></app-meter-request-section>
        </div>
      </div>
  
      <div class="image-container col-13 col-md-4">
        <div
          *ngIf="accountInfo?.customerInformation?.building"
          class="card container"
        >
          <div>{{'COMMON.PICTURES.FRONT' | translate}}</div>
          <div class="images-list">
            <div *ngIf="getFrontViewImage(0)">
              <img
                src="{{ getFrontViewImage(0) }}"
                (click)="showImage(0)"
                data-bs-toggle="modal"
                data-bs-target="#modalImage"
              />
            </div>
  
            <div *ngIf="getFrontViewImage(1)">
              <img
                src="{{ getFrontViewImage(1) }}"
                (click)="showImage(1)"
                data-bs-toggle="modal"
                data-bs-target="#modalImage"
              />
            </div>
  
            <div *ngIf="getFrontViewImage(2)">
              <img
                src="{{ getFrontViewImage(2) }}"
                (click)="showImage(2)"
                data-bs-toggle="modal"
                data-bs-target="#modalImage"
              />
            </div>
          </div>
        </div>
        <div
          *ngIf="accountInfo?.customerInformation?.building"
          class="card container"
        >
          <div>{{'COMMON.PICTURES.TAG_MOUNTED' | translate}}</div>
          <div>
            <div *ngIf="getBuildingMountedImage()">
              <img
                src="{{ getBuildingMountedImage() }}"
                (click)="showImage(3)"
                data-bs-toggle="modal"
                data-bs-target="#modalImage"
              />
            </div>
          </div>
        </div>
        <div class="card container" *ngIf="isExistingCustomer || accountInfo?.clientTypeString == 'Individual'">
          <div>{{'COMMON.PICTURES.CUSTOMER_ID_CARD' | translate}}</div>
          <div class="images-list">
            <div *ngIf="accountInfo?.applicantsSignitureUrl">
              <img
                src="{{ accountInfo?.applicantsSignitureUrl }}"
                (click)="showImage(8)"
                data-bs-toggle="modal"
                data-bs-target="#modalImage"
              />
            </div>
          </div>
        </div>
        <div class="card container" *ngIf="!isExistingCustomer">
          <div>{{'COMMON.PICTURES.ELECT_CONTRACTOR_SIGNATURE' | translate}}</div>
          <div class="images-list">
            <div *ngIf="accountInfo?.electricalContractorsSignitureUrl">
               <button class="btn btn-outline-dark" (click)="openPdf(accountInfo.electricalContractorsSignitureUrl ?? '')">View PDF</button>
            </div>
          </div>
        </div>
        <div class="card container">
          <div>{{'COMMON.PICTURES.APPLICANT_PASSPORT' | translate}}</div>
          <div class="images-list">
            <div *ngIf="accountInfo?.passportUrl">
              <img
                src="{{ accountInfo?.passportUrl }}"
                (click)="showImage(9)"
                data-bs-toggle="modal"
                data-bs-target="#modalImage"
              />
            </div>
          </div>
        </div>
          <div class="card container" *ngIf="!isExistingCustomer && accountInfo?.ownershipStatus == 'Owner'">
    <div>{{'COMMON.PDF.PROOF_OWNERSHIP' | translate}}</div>
    <div class="images-list">
      <div>
        <button class="btn btn-outline-dark" (click)="openPdf(accountInfo.proofOfOwnershipUrl ?? '')">View PDF</button>
      </div>
    </div>
  </div>
  <div class="card container" *ngIf="!isExistingCustomer && accountInfo?.ownershipStatus == 'Tenant'">
    <div>{{'COMMON.PDF.LETTER_CONSENT' | translate}}</div>
    <div class="images-list">
      <div>
        <button class="btn btn-outline-dark" (click)="openPdf(accountInfo.letterOfConsentUrl ?? '')">View PDF</button>
      </div>
    </div>
  </div>
  <div class="card container" *ngIf="!isExistingCustomer && accountInfo?.ownershipStatus == 'Tenant'">
    <div>{{'COMMON.PDF.AGREEMENT' | translate}}</div>
    <div class="images-list">
      <div>

        <button class="btn btn-outline-dark" (click)="openPdf(accountInfo?.tenancyAgreementUrl ?? '')">View PDF</button>
      </div>
    </div>
  </div>
  <div class="card container" *ngIf="!isExistingCustomer && accountInfo?.clientTypeString != 'Individual' && accountInfo?.clientTypeString != null">
    <div>{{'COMMON.PDF.LETTER_AUTHRIZATION' | translate}}</div>
    <div class="images-list">
      <div>
        <button class="btn btn-outline-dark" (click)="openPdf(accountInfo.letterOfAuthorizationUrl ?? '')">View PDF</button>
      </div>
    </div>
  </div>
</div>
      </div>
    </div>
  <div class="modal modalMap" id="showImageMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isImageMapVisible" [longitude]="selectedImage?.longitude"
          [latitude]="selectedImage?.latitude"></app-building-map>
      </div>
    </div>
  </div>
</div>

<div
    class="modal fade"
    id="modalImage"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    (hidden.bs.modal)="onModalFade()"
    (shown.bs.modal)="onModalOpen()"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content modal-image">
        <div class="modal-body modal-body-image">
          <div
            class="image-container"
            [style.transform]="'rotate(' + currentRotation + 'deg)'"
          >
            <lib-ngx-image-zoom
              [zoomMode]="'hover-freeze'"
              [fullImage]="selectedImage?.url"
              [thumbImage]="selectedImage?.url"
              [magnification]="3"
            >
            </lib-ngx-image-zoom>
          </div>
          <div class="rotate-div">
            <button class="btn btn-primary left-button" (click)="rotateLeft()">
              &lt;
            </button>
            <button class="btn btn-primary right-button" (click)="rotateRight()">
              &gt;
            </button>
          </div>
          <app-image-geo-info [image]="selectedImage"
            (mapClicked)="isImageMapVisible = !isImageMapVisible"></app-image-geo-info>
        </div>
      </div>
    </div>
  </div>

  <div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true" (shown.bs.modal)="onGeolocationMapModalOpen()" (hidden.bs.modal)="onGeolocationMapModalFade()">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <app-geolocation-map-viewer
            *ngIf="selectedMapLatitude != null && selectedMapLongitude != null"
            [setMapVisibility]="isGeolocationMapVisible"
            [longitude]="selectedMapLongitude"
            [latitude]="selectedMapLatitude"
          ></app-geolocation-map-viewer>
        </div>
      </div>
    </div>
  </div>
  
  <div
    class="modal"
    id="updateStatus"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    (hidden.bs.modal)="cancelModal()"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{'COMMON.DATA_VALID_REVIEW' | translate}}</h5>
          <button
            type="button"
            #closeDQModal
            class="btn-cancel-modal"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="cancelModal()"
          >
          {{'COMMON.CANCEL' | translate}}
          </button>
        </div>
        <div
          *ngIf="!showApprove && !showReject && !showSuspend"
          class="modal-footer updateStatus updateStatus-nowrap"
        >
          <button
            type="button"
            class="btn btn-primary approve"
            (click)="approve($event)"
          >
            {{'COMMON.APPROVE' | translate}}
          </button>
          <button type="button" class="btn btn-danger" (click)="reject($event)">
            {{'COMMON.REJECT' | translate}}
          </button>
          <button type="button" class="btn btn-suspend" (click)="suspend($event)">
            {{'COMMON.SUSPEND' | translate}}
          </button>
        </div>
        <div *ngIf="showApprove" class="modal-footer updateStatus">
          <div>
            <h3>{{'DATA_QUALITY.APPROVE' | translate}}</h3>
          </div>

          <button
            type="button"
            class="btn btn-primary approve"
            (click)="submitApproval()"
          >
            {{'COMMON.YES' | translate}}
          </button>
          <button type="button" (click)="cancel($event)" class="btn btn-danger">
            {{'COMMON.NO' | translate}}
          </button>
        </div>
        <div *ngIf="showSuspend" class="modal-footer updateStatus">
          <div>
            <h3>{{'COMMON.SUSPEND_CONFIRM' | translate}}</h3>
          </div>
          <button type="button" class="btn btn-primary approve" (click)="submitSuspend()">
            {{'COMMON.YES' | translate}}
          </button>
          <button type="button" (click)="cancel($event)" class="btn btn-danger">
            {{'COMMON.NO' | translate}}
          </button>
        </div>
        <div class="modal-body">
          <div *ngIf="showReject">
            <form class="form-wrapper">
              <div class="row">
                <div class="rejection-section rejection-select col-12">
                  <label class="select-label">{{'NEW_SERVICE_KYC.INCOMPLETE_INFO' | translate}}</label>
                  <div class="form-item form-floating mb-3">
                    <select
                      #missingInformation
                      (change)="onSelectChange(missingInformation.value, 'missingInfo')"
                      class="form-select"
                    >
                      <option disabled selected>{{'COMMON.SELECT_OPTION' | translate}}</option>
                      <option value="Yes">{{'COMMON.YES' | translate}}</option>
                      <option value="No">{{'COMMON.NO' | translate}}</option>
                    </select>
                  </div>
                </div>

                <div *ngIf="informationMissing" class="rejection-section missing-info-checkboxes col-12">
                  <label class="select-label">Sections with Incomplete Information</label>

                  <div class="rejection-section rejection-select col-12">
                    <label class="select-label">Customer Data Incomplete</label>
                    <div class="form-item form-floating mb-3">
                      <select
                        #customerDataSelect
                        (change)="onSelectChange(customerDataSelect.value, 'customerData')"
                        class="form-select"
                      >
                        <option disabled selected>{{'COMMON.SELECT_OPTION' | translate}}</option>
                        <option value="Yes">{{'COMMON.YES' | translate}}</option>
                        <option value="No">{{'COMMON.NO' | translate}}</option>
                      </select>
                    </div>
                  </div>
                  <div *ngIf="customerDataMissing" class="rejection-section missing-info-checkboxes col-12">
                    <label class="select-label">Fields to correct</label>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isCustomerDataFieldSelected('FirstName')" (change)="toggleCustomerDataField('FirstName')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">First Name</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isCustomerDataFieldSelected('Surname')" (change)="toggleCustomerDataField('Surname')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Surname</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isCustomerDataFieldSelected('OwnershipStatus')" (change)="toggleCustomerDataField('OwnershipStatus')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Ownership Status</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isCustomerDataFieldSelected('BuildingOwnersName')" (change)="toggleCustomerDataField('BuildingOwnersName')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Building Owner's Name</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isCustomerDataFieldSelected('ServiceType')" (change)="toggleCustomerDataField('ServiceType')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Service Type</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isCustomerDataFieldSelected('SubServiceType')" (change)="toggleCustomerDataField('SubServiceType')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Service Request Type</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isCustomerDataFieldSelected('CustomerType')" (change)="toggleCustomerDataField('CustomerType')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Customer Type</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isCustomerDataFieldSelected('ClientType')" (change)="toggleCustomerDataField('ClientType')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Client Type</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isCustomerDataFieldSelected('IdentificationType')" (change)="toggleCustomerDataField('IdentificationType')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Identification (ID Type)</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isCustomerDataFieldSelected('PersonalIdNumber')" (change)="toggleCustomerDataField('PersonalIdNumber')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Personal ID Number</label></div>
                    </div>
                    <div class="row">
                      <div class="col-12 rejection-reason">
                        <label>{{'COMMON.REASON_FOR_REJECT' | translate}}</label>
                        <div *ngFor="let option of CUSTOMER_DATA_REJECTION_OPTIONS" class="row rejection-checkbox">
                          <div class="col-1 rejection-checkbox-input">
                            <input type="checkbox"
                              [checked]="isRejectionOptionSelected('customerData', option)"
                              (change)="toggleRejectionOption('customerData', option)" />
                          </div>
                          <div class="col-11"><label class="checkbox-title">{{ option }}</label></div>
                        </div>
                        <div *ngIf="isOtherSelected('customerData')" class="form-item form-floating mb-3 mt-2">
                          <input class="rejection-input" [(ngModel)]="customerDataRejectionOther"
                            name="customerDataRejectionOther" type="text" placeholder="Please describe..." />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="rejection-section rejection-select col-12">
                    <label class="select-label">Service Point Data Incomplete</label>
                    <div class="form-item form-floating mb-3">
                      <select
                        #servicePointDataSelect
                        (change)="onSelectChange(servicePointDataSelect.value, 'servicePointData')"
                        class="form-select"
                      >
                        <option disabled selected>{{'COMMON.SELECT_OPTION' | translate}}</option>
                        <option value="Yes">{{'COMMON.YES' | translate}}</option>
                        <option value="No">{{'COMMON.NO' | translate}}</option>
                      </select>
                    </div>
                  </div>
                  <div *ngIf="servicePointDataMissing" class="rejection-section missing-info-checkboxes col-12">
                    <label class="select-label">Fields to correct</label>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isServicePointFieldSelected('Region')" (change)="toggleServicePointField('Region')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Region</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isServicePointFieldSelected('Area')" (change)="toggleServicePointField('Area')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Area</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isServicePointFieldSelected('UseOfPremise')" (change)="toggleServicePointField('UseOfPremise')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Use of Premise</label></div>
                    </div>
                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input type="checkbox" [checked]="isServicePointFieldSelected('Geolocation')" (change)="toggleServicePointField('Geolocation')" />
                      </div>
                      <div class="col-11"><label class="checkbox-title">Geolocation</label></div>
                    </div>
                    <div class="row">
                      <div class="col-12 rejection-reason">
                        <label>{{'COMMON.REASON_FOR_REJECT' | translate}}</label>
                        <div *ngFor="let option of SERVICE_POINT_REJECTION_OPTIONS" class="row rejection-checkbox">
                          <div class="col-1 rejection-checkbox-input">
                            <input type="checkbox"
                              [checked]="isRejectionOptionSelected('servicePoint', option)"
                              (change)="toggleRejectionOption('servicePoint', option)" />
                          </div>
                          <div class="col-11"><label class="checkbox-title">{{ option }}</label></div>
                        </div>
                        <div *ngIf="isOtherSelected('servicePoint')" class="form-item form-floating mb-3 mt-2">
                          <input class="rejection-input" [(ngModel)]="servicePointDataRejectionOther"
                            name="servicePointDataRejectionOther" type="text" placeholder="Please describe..." />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rejection-section rejection-select col-12">
                    <label class="select-label">Meter Request - Reason for Rejection</label>
                    <div class="row">
                      <div class="col-12 rejection-reason">
                        <input
                          class="rejection-input"
                          [(ngModel)]="meterRequestRejectionReason"
                          name="meterRequestRejectionReason"
                          type="text"
                          placeholder="Please describe..."
                        />
                      </div>
                    </div>
                  </div>
                    <div class="rejection-section rejection-select col-12">
                    <label class="select-label">Files to re-upload</label>
                    <div class="form-item form-floating mb-3">
                      <select
                        #filesMissingSelect
                        (change)="onSelectChange(filesMissingSelect.value, 'filesMissing')"
                        class="form-select"
                      >
                        <option disabled selected>{{'COMMON.SELECT_OPTION' | translate}}</option>
                        <option value="Yes">{{'COMMON.YES' | translate}}</option>
                        <option value="No">{{'COMMON.NO' | translate}}</option>
                      </select>
                    </div>
                  </div>
                  <div *ngIf="filesMissing" class="rejection-section missing-info-checkboxes col-12">
                    <label class="select-label">{{'NEW_SERVICE_KYC.FILES_REUPLOAD' | translate}}</label>

                    <div class="row rejection-checkbox" *ngIf="!isExistingCustomer">
                      <div class="col-1 rejection-checkbox-input">
                        <input
                          type="checkbox"
                          [checked]="isFilesFieldSelected(KycRejectedImage.ElectricalContractorsSignature)"
                          (change)="toggleFilesField(KycRejectedImage.ElectricalContractorsSignature)"
                        />
                      </div>
                      <div class="col-11">
                        <label class="checkbox-title">Licensed Electrical Contractor Certificate</label>
                      </div>
                    </div>

                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input
                          type="checkbox"
                          [checked]="isFilesFieldSelected(KycRejectedImage.NinCard)"
                          (change)="toggleFilesField(KycRejectedImage.NinCard)"
                        />
                      </div>
                      <div class="col-11">
                        <label class="checkbox-title">Picture of NIN Card</label>
                      </div>
                    </div>

                    <div class="row rejection-checkbox">
                      <div class="col-1 rejection-checkbox-input">
                        <input
                          type="checkbox"
                          [checked]="isFilesFieldSelected(KycRejectedImage.ApplicantsPassportPhotograph)"
                          (change)="toggleFilesField(KycRejectedImage.ApplicantsPassportPhotograph)"
                        />
                      </div>
                      <div class="col-11">
                        <label class="checkbox-title">{{'NEW_SERVICE_KYC.APPLICANT_PASSPORT' | translate}}</label>
                      </div>
                    </div>

                    <div class="row rejection-checkbox" *ngIf="!isExistingCustomer">
                      <div class="col-1 rejection-checkbox-input">
                        <input
                          type="checkbox"
                          [checked]="isFilesFieldSelected(KycRejectedImage.ProofOfOwnership)"
                          (change)="toggleFilesField(KycRejectedImage.ProofOfOwnership)"
                        />
                      </div>
                      <div class="col-11">
                        <label class="checkbox-title">
                          Proof of Ownership (C of O, Deeds of Assignment, Land Use Charge, Land Receipt)
                        </label>
                      </div>
                    </div>

                    <div class="row rejection-checkbox" *ngIf="!isExistingCustomer">
                      <div class="col-1 rejection-checkbox-input">
                        <input
                          type="checkbox"
                          [checked]="isFilesFieldSelected(KycRejectedImage.LetterOfConsent)"
                          (change)="toggleFilesField(KycRejectedImage.LetterOfConsent)"
                        />
                      </div>
                      <div class="col-11">
                        <label class="checkbox-title">Letter of Consent from Landlord</label>
                      </div>
                    </div>

                    <div class="row rejection-checkbox" *ngIf="!isExistingCustomer">
                      <div class="col-1 rejection-checkbox-input">
                        <input
                          type="checkbox"
                          [checked]="isFilesFieldSelected(KycRejectedImage.TenancyAgreement)"
                          (change)="toggleFilesField(KycRejectedImage.TenancyAgreement)"
                        />
                      </div>
                      <div class="col-11">
                        <label class="checkbox-title">Tenancy Agreement</label>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 rejection-reason">
                        <label>{{'COMMON.REASON_FOR_REJECT' | translate}}</label>
                        <div *ngFor="let option of FILES_REJECTION_OPTIONS" class="row rejection-checkbox">
                          <div class="col-1 rejection-checkbox-input">
                            <input type="checkbox"
                              [checked]="isRejectionOptionSelected('files', option)"
                              (change)="toggleRejectionOption('files', option)" />
                          </div>
                          <div class="col-11"><label class="checkbox-title">{{ option }}</label></div>
                        </div>
                        <div *ngIf="isOtherSelected('files')" class="form-item form-floating mb-3 mt-2">
                          <input class="rejection-input" [(ngModel)]="filesRejectionOther"
                            name="filesRejectionOther" type="text" placeholder="Please describe..." />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div class="buttons">
              <button class="btn btn-primary" (click)="trySubmitRejection()">
                {{'DATA_QUALITY.SUBMIT_REJECTION' | translate}}
              </button>
              <button
                class="btn btn-danger"
                style="margin-left: 1rem"
                (click)="cancel($event)"
              >
                {{'COMMON.CANCEL' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
